import React from 'react';
import { useLazyLoading } from '../hooks/useLazyLoading';

const LazyComponent = ({
  children,
  fallback = null,
  threshold = 0.1,
  rootMargin = '100px',
  delay = 0,
  className = '',
  style = {},
  onLoad = null
}) => {
  const { elementRef, isVisible, isLoaded, shouldRender } = useLazyLoading({
    threshold,
    rootMargin,
    delay,
    triggerOnce: true
  });

  React.useEffect(() => {
    if (isLoaded && onLoad) {
      onLoad();
    }
  }, [isLoaded, onLoad]);

  if (!shouldRender) {
    return (
      <div
        ref={elementRef}
        className={`lazy-loading-placeholder ${className}`}
        style={{
          minHeight: '200px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...style
        }}
      >
        {fallback || (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">جاري التحميل...</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      ref={elementRef}
      className={`lazy-loading ${isLoaded ? 'loaded' : ''} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default LazyComponent;
